import { render, staticRenderFns } from "./LoadFileDetail.vue?vue&type=template&id=086f4cec&scoped=true"
import script from "./LoadFileDetail.vue?vue&type=script&lang=js"
export * from "./LoadFileDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086f4cec",
  null
  
)

export default component.exports